export enum champsReactivationEnum {
	expiration_date = 'expiration_date'
}